import { render, staticRenderFns } from "./AlarmListDefaultLayout.vue?vue&type=template&id=5434dbf4&scoped=true"
import script from "./AlarmListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AlarmListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434dbf4",
  null
  
)

export default component.exports